<main class="edi-home" *ngIf="!minimize">
  <header class="edi-page-header">
    <h3 class="page-title text-center" translate>EDI</h3>
    <p>Review document flows, resolve processing issues and manage your EDI setup.</p>
  </header>

  <section class="edi-section" aria-labelledby="edi-message-flows">
    <div class="edi-section-heading">
      <div>
        <h3 id="edi-message-flows">Message flows</h3>
        <p>Incoming and outgoing business documents.</p>
      </div>
    </div>

    <div class="edi-flow-group">
      <div class="edi-flow-heading">
        <h4>Customer order flow</h4>
        <span>Order <i class="fa-solid fa-arrow-right"></i> Response <i class="fa-solid fa-arrow-right"></i> Despatch <i class="fa-solid fa-arrow-right"></i> Invoice</span>
      </div>
      <div class="edi-tile-grid">
        <a class="edi-tile" routerLink="orders">
          <div class="edi-tile-topline">
            <span class="edi-tile-icon edi-tile-icon--incoming" aria-hidden="true"><i class="fa-solid fa-cart-arrow-down"></i></span>
            <span class="edi-direction edi-direction--incoming">Incoming</span>
          </div>
          <h4>Orders</h4>
          <p>Review received orders, resolve validation issues and send them to the ERP.</p>
          <span class="edi-open">Open orders <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>

        <a class="edi-tile" routerLink="order-responses">
          <div class="edi-tile-topline">
            <span class="edi-tile-icon edi-tile-icon--outgoing" aria-hidden="true"><i class="fa-solid fa-reply"></i></span>
            <span class="edi-direction edi-direction--outgoing">Outgoing</span>
          </div>
          <h4>Order responses</h4>
          <p>Review acknowledgements and responses created for incoming orders.</p>
          <span class="edi-open">Open order responses <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>

        <a class="edi-tile" routerLink="dispatch-advices">
          <div class="edi-tile-topline">
            <span class="edi-tile-icon edi-tile-icon--outgoing" aria-hidden="true"><i class="fa-solid fa-truck-fast"></i></span>
            <span class="edi-direction edi-direction--outgoing">Outgoing</span>
          </div>
          <h4>Despatch advices</h4>
          <p>Review generated delivery messages and their delivery status.</p>
          <span class="edi-open">Open despatch advices <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>

        <a class="edi-tile" routerLink="invoices">
          <div class="edi-tile-topline">
            <span class="edi-tile-icon edi-tile-icon--outgoing" aria-hidden="true"><i class="fa-solid fa-file-invoice-dollar"></i></span>
            <span class="edi-direction edi-direction--outgoing">Outgoing</span>
          </div>
          <h4>Invoices</h4>
          <p>Review generated invoices and their delivery status.</p>
          <span class="edi-open">Open invoices <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>
      </div>
    </div>

    <div class="edi-flow-group">
      <div class="edi-flow-heading">
        <h4>Supplier order flow</h4>
        <span>Purchase order <i class="fa-solid fa-arrow-right"></i> Response <i class="fa-solid fa-arrow-right"></i> Despatch</span>
      </div>
      <div class="edi-tile-grid">
        <a class="edi-tile" routerLink="purchased-orders">
          <div class="edi-tile-topline">
            <span class="edi-tile-icon edi-tile-icon--outgoing" aria-hidden="true"><i class="fa-solid fa-file-export"></i></span>
            <span class="edi-direction edi-direction--outgoing">Outgoing</span>
          </div>
          <h4>Purchase orders</h4>
          <p>Review purchase orders sent to suppliers and manage retransmissions.</p>
          <span class="edi-open">Open purchase orders <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>

        <a class="edi-tile" routerLink="incoming-order-responses" *ngIf="incomingOrderResponsesEnabled">
          <div class="edi-tile-topline">
            <span class="edi-tile-icon edi-tile-icon--incoming" aria-hidden="true"><i class="fa-solid fa-share"></i></span>
            <span class="edi-direction edi-direction--incoming">Incoming</span>
          </div>
          <h4>Order responses</h4>
          <p>Review order responses received from suppliers.</p>
          <span class="edi-open">Open incoming responses <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>

        <a class="edi-tile" routerLink="incoming-despatch-advices">
          <div class="edi-tile-topline">
            <span class="edi-tile-icon edi-tile-icon--incoming" aria-hidden="true"><i class="fa-solid fa-truck-ramp-box"></i></span>
            <span class="edi-direction edi-direction--incoming">Incoming</span>
          </div>
          <h4>Despatch advices</h4>
          <p>Review delivery information received from suppliers.</p>
          <span class="edi-open">Open incoming advices <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>
      </div>
    </div>

    <div class="edi-flow-group" *ngIf="pricatsEnabled">
      <div class="edi-flow-heading">
        <h4>Catalog messages</h4>
      </div>
      <div class="edi-tile-grid">
        <a class="edi-tile" routerLink="pricats">
          <div class="edi-tile-topline">
            <span class="edi-tile-icon edi-tile-icon--outgoing" aria-hidden="true"><i class="fa-solid fa-tags"></i></span>
            <span class="edi-direction edi-direction--outgoing">Outgoing</span>
          </div>
          <h4>{{ 'MANAGE_PRICATS' | translate }}</h4>
          <p>{{ 'MANAGE_PRICATS_DESCRIPTION' | translate }}</p>
          <span class="edi-open">Open PRICAT messages <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>
      </div>
    </div>
  </section>

  <section class="edi-section" aria-labelledby="edi-tools-settings">
    <div class="edi-section-heading">
      <div>
        <h3 id="edi-tools-settings">Tools and settings</h3>
        <p>Inspect documents, import data and maintain integration configuration.</p>
      </div>
    </div>

    <div class="edi-tool-grid">
      <a class="edi-tool" routerLink="mappings" *ngIf="mappingModellerEnabled">
        <span class="edi-tool-icon" aria-hidden="true"><i class="fa-solid fa-diagram-project"></i></span>
        <span>
          <strong>EDI mappings</strong>
          <small>Create, edit, version and test mappings with their saved source fixtures.</small>
        </span>
        <i class="fa-solid fa-chevron-right edi-tool-arrow" aria-hidden="true"></i>
      </a>

      <a class="edi-tool" routerLink="viewer" *ngIf="documentViewerEnabled">
        <span class="edi-tool-icon" aria-hidden="true"><i class="fa-regular fa-file-code"></i></span>
        <span>
          <strong>EDI document viewer</strong>
          <small>Open a raw EDI document in a human-friendly view.</small>
        </span>
        <i class="fa-solid fa-chevron-right edi-tool-arrow" aria-hidden="true"></i>
      </a>

      <a class="edi-tool" routerLink="import-xml">
        <span class="edi-tool-icon" aria-hidden="true"><i class="fa-solid fa-upload"></i></span>
        <span>
          <strong>Import EDI orders</strong>
          <small>Upload an XML order and process it with an EDI configuration.</small>
        </span>
        <i class="fa-solid fa-chevron-right edi-tool-arrow" aria-hidden="true"></i>
      </a>

      <a class="edi-tool" routerLink="gln-numbers">
        <span class="edi-tool-icon" aria-hidden="true"><i class="fa-solid fa-address-book"></i></span>
        <span>
          <strong>GLN numbers</strong>
          <small>Browse EDI parties and maintain their settings.</small>
        </span>
        <i class="fa-solid fa-chevron-right edi-tool-arrow" aria-hidden="true"></i>
      </a>

      <a class="edi-tool" routerLink="configurations" *ngIf="configurationsEnabled">
        <span class="edi-tool-icon" aria-hidden="true"><i class="fa-solid fa-sliders"></i></span>
        <span>
          <strong>Configurations</strong>
          <small>List and edit EDI instance configurations.</small>
        </span>
        <i class="fa-solid fa-chevron-right edi-tool-arrow" aria-hidden="true"></i>
      </a>

      <a class="edi-tool" routerLink="/admin/ean/ean-repository">
        <span class="edi-tool-icon" aria-hidden="true"><i class="fa-solid fa-barcode"></i></span>
        <span>
          <strong>EAN repository</strong>
          <small>View product identifiers synchronized from the ERP.</small>
        </span>
        <i class="fa-solid fa-chevron-right edi-tool-arrow" aria-hidden="true"></i>
      </a>
    </div>
  </section>

  <section class="edi-section" aria-labelledby="edi-extra-tools" *ngIf="extraTiles && extraTiles.length > 0">
    <div class="edi-section-heading">
      <div>
        <h3 id="edi-extra-tools">Additional tools</h3>
      </div>
    </div>
    <div class="edi-tool-grid">
      <a class="edi-tool" [routerLink]="tile.routerLink" *ngFor="let tile of extraTiles">
        <span class="edi-tool-icon" aria-hidden="true"><i class="fa-solid fa-puzzle-piece"></i></span>
        <span>
          <strong translate>{{ tile.title }}</strong>
          <small translate>{{ tile.description }}</small>
        </span>
        <i class="fa-solid fa-chevron-right edi-tool-arrow" aria-hidden="true"></i>
      </a>
    </div>
  </section>
</main>

<router-outlet></router-outlet>
